import { Dialog, DialogContent, IconButton } from '@mui/material';
import i18n from '../../../../../utils/i18n';
import CustomButton from '../../../../components/CustomButton';
import AIHeaderClose from '../../../../../images/ai-header-close.svg';
import CheckCircleOn from '../../../images/check-circle-on.svg';
import IconSubSuccessWhite from '../../../../../images/icon-sub-success-white.svg';

const SubscriptionSuccess = ({
	openSubSuccess,
	setOpenSubSuccess,
	title,
	subTitle,
	firstRow,
	secondRow,
	thirdRow,
	onConfirm,
}) => {
	const handleCloseSubSuccess = () => {
		setOpenSubSuccess(false);
	};

	return (
		<Dialog
			open={openSubSuccess}
			onClose={handleCloseSubSuccess}
			PaperProps={{
				sx: {
					width: '420px',
					height: 'auto',
					maxWidth: 'none',
					borderRadius: '18px',
					overflow: 'hidden',
				},
			}}
			sx={{
				'& .MuiDialog-container': {
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				},
				'& .MuiDialog-paper': {
					width: '420px',
					maxWidth: 'none',
				},
			}}>
			<div
				style={{
					position: 'relative',
					width: '420px',
					height: '128px',
					background: '#1ccc5a',
					borderRadius: '18px 18px 0 0',
					overflow: 'hidden',
				}}>
				<img
					src={IconSubSuccessWhite}
					alt='IconSuccess'
					style={{
						width: '32px',
						height: 'auto',
						objectFit: 'contain',
						position: 'absolute',
						top: 'calc(50%)',
						left: '50%',
						transform: 'translate(-50%, -50%)',
					}}
				/>

				<IconButton
					aria-label='close'
					onClick={handleCloseSubSuccess}
					sx={{
						position: 'absolute',
						top: '8px',
						right: '8px',
						color: '#ffffff',
						padding: '8px',
						userSelect: 'none',
						backgroundColor: 'transparent',
						outline: 'none',
						'&:focus': { outline: 'none' },
						'&:active': { backgroundColor: 'transparent' },
					}}>
					<img
						src={AIHeaderClose}
						alt='AIHeaderClose'
						style={{
							width: '24px',
							height: '24px',
							objectFit: 'contain',
							pointerEvents: 'none',
						}}
					/>
				</IconButton>
			</div>

			<DialogContent
				sx={{
					padding: '18px',
					height: 'auto',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'flex-start',
					overflowY: 'auto',
					scrollbarWidth: 'thin', // Firefox support
					scrollbarColor: '#8791b4 #f1f1f1', // Firefox support

					/* Scrollbar Webkit (Chrome, Safari, Edge) */
					'&::-webkit-scrollbar': {
						width: '10px',
						backgroundColor: '#f1f1f1',
					},
					'&::-webkit-scrollbar-track': {
						backgroundColor: '#e0e0ff',
						borderRadius: '10px',
					},
					'&::-webkit-scrollbar-thumb': {
						backgroundColor: '#8791b4',
						borderRadius: '10px',
						border: '2px solid #e0e0ff',
					},
					'&::-webkit-scrollbar-thumb:hover': {
						backgroundColor: '#6c7493',
					},
				}}>
				<div style={{ width: '100%' }}>
					<div
						style={{
							fontSize: '16px',
							fontWeight: '700',
							color: '#0b0f31',
							margin: '4px 0',
						}}>
						{title}
					</div>
					<div
						style={{
							fontSize: '14px',
							fontWeight: '500',
							color: '#4b5080',
							margin: '4px 0 12px 0',
						}}>
						{subTitle}
					</div>

					<div>
						<div style={{ display: 'flex' }}>
							<img
								src={CheckCircleOn}
								alt='CheckIcon'
								style={{ marginRight: '6px' }}
							/>
							<div
								style={{
									fontSize: '14px',
									fontWeight: '500',
									color: '#0b0f31',
									margin: '12px 0',
								}}>
								{firstRow}
							</div>
						</div>
						<div style={{ display: 'flex' }}>
							<img
								src={CheckCircleOn}
								alt='CheckIcon'
								style={{ marginRight: '6px' }}
							/>
							<div
								style={{
									fontSize: '14px',
									fontWeight: '500',
									color: '#0b0f31',
									margin: '12px 0',
								}}>
								{secondRow}
							</div>
						</div>
						<div style={{ display: 'flex' }}>
							<img
								src={CheckCircleOn}
								alt='CheckIcon'
								style={{ marginRight: '6px' }}
							/>
							<div
								style={{
									fontSize: '14px',
									fontWeight: '500',
									color: '#0b0f31',
									margin: '12px 0',
								}}>
								{thirdRow}
							</div>
						</div>
					</div>

					<div style={{ margin: '18px 0' }}>
						<CustomButton
							buttonName={i18n.t('provider.subsuccessbuttonnext')}
							buttonColor='#1c32f3'
							hoverColor='#0036cc'
							titleColor='#ffffff'
							titleHoverColor='#e0e0e0'
							width='100%'
							height='44px'
							padding='12px'
							onClick={handleCloseSubSuccess}
						/>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	);
};

export default SubscriptionSuccess;
